module.exports = __webpack_public_path__ + "static/media/SSTienLen.f79f3318.png";